import type { BroadcastState } from "@riq/api";

export type LinearPlaybackSource = "live" | "station";

export function resolveLinearTarget(
  broadcastState: BroadcastState,
  stationAvailable: boolean,
): LinearPlaybackSource | null {
  if (broadcastState.isLive) return "live";
  if (stationAvailable) return "station";
  return null;
}

/**
 * Resolve a station track's audio URL. CDN-served tracks carry an absolute URL
 * (public R2 custom domain); proxied tracks carry an API-relative path that needs
 * the API base prepended.
 */
export function resolveStationAudioUrl(baseUrl: string, audioUrl: string): string {
  if (/^https?:\/\//i.test(audioUrl)) return audioUrl;
  return `${baseUrl}${audioUrl}`;
}
